import { URLParam } from "@/helpers/interfaces/URLParam.ts";
import { useEngineStore } from "@/stores/EngineStore/EngineStore.ts";
import { isBefore, parseISO } from "date-fns";
import { useEffect } from "react";

// Gets initial date range from URL and sets it in the store
// covers edge cases like dates in the past or end date before start date
export const useDateURLParams = () => {
  const setDateRange = useEngineStore((state) => state.setDefaultDateRange);

  const setDefaultDateRange = () => {
    const tomorrowDate = new Date(+new Date() + 86400000);
    const dayAfterTomorrowDate = new Date(+tomorrowDate + 86400000);
    setDateRange([tomorrowDate, dayAfterTomorrowDate]);
  };

  useEffect(() => {
    const today = new Date().setHours(0, 0, 0, 0);
    const urlParams = new URLSearchParams(window.location.search);
    const startDateParam = urlParams.get(URLParam.StartDate);
    const endDateParam = urlParams.get(URLParam.EndDate);

    const startDate = startDateParam ? parseISO(startDateParam) : null;
    const endDate = endDateParam ? parseISO(endDateParam) : null;

    if (
      !startDate ||
      !endDate ||
      isBefore(startDate, today) ||
      isBefore(endDate, today) ||
      isBefore(endDate, startDate)
    ) {
      setDefaultDateRange();
    } else {
      setDateRange([startDate, endDate]);
    }
    // eslint-disable-next-line
  }, []);
};
